import { FC, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { Button, Divider } from '@cargomart/ui'
import MapPointAIcon from 'assets/map-point-a.svg?react'
import MapPointBIcon from 'assets/map-point-b.svg?react'
import { OrderYarcheCreateCargo, TerminalItem } from 'schema'
import { useIsMobile } from 'src/hooks'

import { useGetAllYarcheTerminalsQuery } from '../api'
import { useYarcheDestinationDate } from '../hooks'
import { OrderYarcheCreateFormData } from '../pages/OrderYarcheCreatePage/types'
import OrderGuestSubmit from './OrderGuestKDVIDCreateForm/OrderGuestSubmit'
import OrderYarcheCreateSummaryCargo from './OrderYarcheCreateSummaryCargo'
import OrderYarcheCreateSummaryDeliveryDate from './OrderYarcheCreateSummaryDeliveryDate'
import OrderYarcheCreateSummaryTotalPrice from './OrderYarcheCreateSummaryTotalPrice'

interface OrderYarcheGuestCreateSummaryProps {
  isShowPhone: boolean
  className?: string
}

const OrderYarcheGuestCreateSummary: FC<OrderYarcheGuestCreateSummaryProps> = ({ className, isShowPhone }) => {
  const isMobile = useIsMobile()
  const { values } = useFormState<OrderYarcheCreateFormData>()
  const { departurePoint, destinationPoint, cargo } = values
  const { deliveryDate, isLoading } = useYarcheDestinationDate({ departurePoint, destinationPoint })
  const { data: terminals } = useGetAllYarcheTerminalsQuery('')

  const terminalsById = useMemo(
    () =>
      (terminals || []).reduce<Record<TerminalItem['id'], TerminalItem>>((acc, item) => {
        acc[item.id] = item

        return acc
      }, {}),
    [terminals]
  )

  const [departurePointTerminal, destinationPointTerminal] = useMemo(
    () => [
      departurePoint?.terminalId ? terminalsById[departurePoint?.terminalId] : null,
      destinationPoint?.terminalId ? terminalsById[destinationPoint?.terminalId] : null
    ],
    [departurePoint, destinationPoint, terminalsById]
  )

  return (
    <div className={className}>
      <div className="text-headline-sm">Предварительный расчёт</div>
      <div className="py-6">
        <div className="mb-2 flex gap-1 text-body-md">
          <MapPointAIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
          <div>{departurePointTerminal?.address || '—'}</div>
        </div>
        <div className="flex gap-1 text-body-md">
          <MapPointBIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
          <div>{destinationPointTerminal?.address || '—'}</div>
        </div>
        <Divider className="my-2" />
        <OrderYarcheCreateSummaryCargo cargo={cargo as OrderYarcheCreateCargo} />
        <OrderYarcheCreateSummaryDeliveryDate deliveryDate={deliveryDate?.deliveryDate} isLoading={isLoading} />
        <Divider className="my-2" />
        <OrderYarcheCreateSummaryTotalPrice />
        {!isMobile && (
          <div className="mt-3">
            {isShowPhone ? (
              <OrderGuestSubmit />
            ) : (
              <Button className="w-full" type="submit">
                Заказать
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default OrderYarcheGuestCreateSummary
